import {
  ISystemHealthDropdownItemProps,
  ISystemHealthStatus
} from "./@types/systemhealth";
import { DiskPartitionData } from "../../system-status/@types";

export const prepareHealthData = ({
  isHealthy,
  healthIssues,
  systemHealthStatus
}: {
  isHealthy: boolean;
  healthIssues: string[];
  systemHealthStatus: Partial<ISystemHealthStatus>;
}) => {
  const {
    cpu_utilization: cpuUtilization,
    disk_usage: diskUsage = [],
    free_memory: freeMemory,
    health_checks: {
      disk_usage: isDiskUsageHealthy = true,
      free_memory: isMemoryHealthy = true,
      cpu_utilization: isCpuHealthy = true
    } = {},
    central_manager: {
      is_configured: isCmConfigured = false,
      is_connected: isCmConnected = false
    } = {}
  } = systemHealthStatus || {};

  const healthData: Array<ISystemHealthDropdownItemProps> = [
    {
      id: "disk",
      icon: "disk-partitions",
      title: "Disk Usage",
      content: diskUsage.map((item: DiskPartitionData) => ({
        label: item.device,
        value: `${item.percent}%`
      })),
      isMetricHealthy: isDiskUsageHealthy
    },
    {
      id: "memory",
      icon: "memory",
      title: "Memory",
      content: [{ label: "Free Memory", value: `${freeMemory?.toFixed(2)}%` }],
      isMetricHealthy: isMemoryHealthy
    },
    {
      id: "cpu",
      icon: "cpu",
      title: "CPU",
      content: [{ label: "Utilization", value: `${cpuUtilization}%` }],
      isMetricHealthy: isCpuHealthy
    }
  ];

  if (isCmConfigured) {
    healthData.push({
      id: "cm",
      icon: "configuration-a",
      title: "Spectra Detect Manager Connection",
      content: [isCmConnected ? "Online" : "Offline"]
    });
  }

  healthData.push({
    id: "issues",
    icon: "warning-i",
    title: "Alerts & Issues",
    content: [
      isHealthy ? "No Issues Found" : "Sample processing may be affected",
      ...(healthIssues || [])
    ],
    isMetricHealthy: isHealthy
  });

  return { healthData };
};
